import React from 'react';
import Icon from '../../../components/AppIcon';

const GenerationStepCard = ({ step, status, description }) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'completed':
        return <Icon name="CheckCircle2" size={20} color="#059669" />;
      case 'active':
        return (
          <div className="animate-spin">
            <Icon name="Loader2" size={20} color="#2563EB" />
          </div>
        );
      case 'pending':
        return <Icon name="Circle" size={20} color="#94A3B8" />;
      default:
        return null;
    }
  };

  const getStatusStyles = () => {
    switch (status) {
      case 'completed':
        return 'bg-success/10 border-success/20';
      case 'active':
        return 'bg-primary/10 border-primary/20 shadow-lg';
      case 'pending':
        return 'bg-muted/50 border-border';
      default:
        return '';
    }
  };

  return (
    <div
      className={`flex items-start gap-3 p-4 md:p-5 lg:p-6 rounded-lg border transition-all duration-300 ${getStatusStyles()}`}
    >
      <div className="flex-shrink-0 mt-1">{getStatusIcon()}</div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm md:text-base lg:text-lg font-semibold mb-1 text-foreground">
          {step}
        </h4>
        {description && (
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default GenerationStepCard;